var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThankyou(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.579,
    height: 120.579,
    viewBox: "0 0 120.579 120.579",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4368",
    "data-name": "Group 4368",
    transform: "translate(-635.71 -217.71)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M830.29,570.579a60.29,60.29,0,1,1,60.29-60.29,60.29,60.29,0,0,1-60.29,60.29Z",
    transform: "translate(-134.29 -232.29)",
    fill: "#699f4c",
    fillRule: "evenodd",
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    id: "check-2",
    "data-name": "check",
    d: "M800,510a30,30,0,1,1,30-30,30,30,0,0,1-30,30Z",
    transform: "translate(-104 -202)",
    fill: "#699f4c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check-3",
    "data-name": "check",
    d: "M800,510a30,30,0,1,1,30-30,30,30,0,0,1-30,30Zm-16.986-23.235a3.484,3.484,0,0,1,0-4.9l1.766-1.756a3.185,3.185,0,0,1,4.574.051l3.12,3.237a1.592,1.592,0,0,0,2.311,0l15.9-16.39a3.187,3.187,0,0,1,4.6-.027L817,468.714a3.482,3.482,0,0,1,0,4.846l-21.109,21.451a3.185,3.185,0,0,1-4.552.03Z",
    transform: "translate(-104 -202)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankyou);
export default __webpack_public_path__ + "static/media/thankyou.3a224813bf253424bb231de7c4380fe5.svg";
export { ForwardRef as ReactComponent };